import { yomiriP2P } from './YomiriP2PBridge.ts';
import type { CastSnapshot } from './RemoteSession.ts';
export type CastCommand =
  | { type:'HELLO'; role:'tv'|'remote'; deviceName:string }
  | { type:'NAVIGATE';view:string;params?:Record<string,string> }
  | { type:'SEARCH';query:string }
  | { type:'OPEN_MANGA';id:string;chapterId?:string;manga?:unknown }
  | { type:'OPEN_ANIME';sourceId:string;animeId:string;episodeId?:string }
  | { type:'READER_CONTROL';action:'next'|'prev'|'toggle_fit' }
  | { type:'PLAYER_CONTROL';action:'play'|'pause'|'seek'|'toggle_fullscreen'|'volume_up'|'volume_down'|'mute';time?:number }
  | { type:'DPAD_NAVIGATE';key:'ArrowUp'|'ArrowDown'|'ArrowLeft'|'ArrowRight'|'Enter'|'Escape' }
  | { type:'STATE_SYNC';snapshot:CastSnapshot }
  | { type:'ROUTE_SYNC';search:string }
  | { type:'TV_FEEDBACK';message:string;stage?:'recibido'|'reproduciendo' }
  | { type:'PLAYBACK_STATUS';status:'recibido'|'reproduciendo';message?:string };
export const yomiriCast = {
  initRole(_role:'tv'|'remote',_name:string){ /* Pair explicitly; mounting a component never connects devices. */ },
  getRole:()=>yomiriP2P.getRole(),
  getConnectedPeer:()=>yomiriP2P.getPeerName(),
  send:(command:CastCommand)=>yomiriP2P.send(command),
  subscribe:(listener:(cmd:CastCommand)=>void)=>yomiriP2P.onCommand(listener),
};
